





























































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";
import FormErrorsMixin from "@/mixins/FormErrors";
import Multiselect from "vue-multiselect";

import ViewLoader from "@/components/Common/ViewLoader.vue";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import PasswordInput from "@/components/Common/Inputs/PasswordInput.vue";
import BackButton from "@/components/Common/Buttons/BackButton.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import DangerButton from "@/components/Common/Buttons/DangerButton.vue";
import Error404 from "@/components/Common/Error404.vue";
import { IUser } from "@/interface";
import { AxiosResponse } from "axios";

interface IOption {
  id: number;
  name: string;
}

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    TextInput,
    PasswordInput,
    BackButton,
    InfoButton,
    DangerButton,
    Multiselect,
    Error404
  }
})
export default class User extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "first_name",
    "last_name",
    "email",
    "password",
    "new_password",
    "new_password_confirmation"
  ];
  private noDataExist = false;
  private originalFirstName: string | null = null;
  private originalLastName: string | null = null;
  private selectedUser: IUser = {
    first_name: null,
    last_name: null,
    email: null,
    password: null,
    new_password: null,
    new_password_confirmation: null
  };
  private selectedUserId: string | null = null;
  private facilityValue: Array<IOption> = [
    //
  ];
  private facilityOptions: Array<IOption> = [
    { name: "Mehrzweckhalle", id: 1 },
    { name: "Tennishalle", id: 2 },
    { name: "Kinderspielplatz", id: 3 }
  ];

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedUserId = vm.$route.params.user_id;
      if (
        typeof vm.selectedUserId !== "undefined" &&
        vm.selectedUserId !== null
      ) {
        if (vm.$route.query.user_created === "true") {
          swal("Success!", "The user was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
        vm.getUser(() => {
          //
        });
      }
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (
      typeof this.selectedUserId !== "undefined" &&
      this.selectedUserId !== null
    ) {
      this.getUser(() => {
        //
      });
    }
    next();
  }

  private addFacility(facility: IOption): void {
    this.facilityValue.push(facility);
  }

  private createOrUpdateUser(): void {
    if (this.selectedUserId == null) {
      this.createUser();
    } else {
      this.updateUser();
    }
  }

  private createUser(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint("users");

    Api()
      .post(endpoint, {
        password: this.selectedUser.password,
        email: this.selectedUser.email,
        first_name: this.selectedUser.first_name,
        last_name: this.selectedUser.last_name
      })
      .then((response: AxiosResponse) => {
        this.selectedUserId = response.data.data.id;
        this.$router.push({
          name: "UserDetails",
          params: { user_id: `${this.selectedUserId}` },
          query: { user_created: "true" }
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#user-email", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private getUser(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.resetErrors();
    this.loading = true;
    const endpoint = this.$partnerEndpoint("users/" + this.selectedUserId);

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedUser = response.data.data;
        if (this.selectedUser.first_name) {
          this.originalFirstName = this.selectedUser.first_name;
        }
        if (this.selectedUser.last_name) {
          this.originalLastName = this.selectedUser.last_name;
        }
        if (typeof successCallback === "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateUser(): void {
    if (this.loading || this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "users/" + this.selectedUserId
    );

    Api()
      .put(endpoint, {
        first_name: this.selectedUser.first_name,
        last_name: this.selectedUser.last_name,
        email: this.selectedUser.email,
        new_password: this.selectedUser.new_password,
        new_password_confirmation: this.selectedUser.new_password_confirmation
      })
      .then(() => {
        this.getUser(() => {
          //
        });
        swal({
          title: "Success!",
          text: "The user was updated.",
          icon: "success"
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#user-email", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private deleteUser(): void {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The user will be deleted and will not be able to use his account",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "users/" + this.selectedUserId
        );

        Api()
          .delete(endpoint)
          .then((response: AxiosResponse) => {
            console.log(response.status);
            this.$router.push({
              name: "UsersOverview",
              query: { user_deleted: "true" }
            });
          })
          .catch((error: any) => {
            console.log(error.response);
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete users.",
                icon: "error"
                //dangerMode: true,
              });
            }
            if (error.response.status === 409) {
              swal({
                title: "Your own account",
                text: "You cannot delete your own account.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }
}
